import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconButtonComponent } from '../../buttons/icon-button.component';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'sibat-modal-header',
  template: `
    <div class="header-modal">
      <h2 class="title">
        {{ title }}
      </h2>
      @if (helpLink) {
      <sibat-icon-button [href]="helpLink" icon="help" target="_blank"> </sibat-icon-button>
      }
      <div class="filler"></div>
      <button data-testid="header-modal-close-button" class="close-button" (click)="clicked.emit()">
        <mat-icon color="primary">close</mat-icon>
      </button>
    </div>
  `,
  styleUrls: ['modal-header.component.scss'],
  imports: [IconButtonComponent, MatIcon],
})
export class ModalHeaderComponent {
  @Output() clicked = new EventEmitter<void>();
  @Input() title: string;
  @Input() helpLink?: string;
}
